module.exports = __webpack_public_path__ + "static/media/effacer.51f1a074.png";